import React, { useEffect, useState } from 'react'
import AddEmployeeModal from '../../components/Employee/AddEmployeeModal/AddEmployeeModal';
import EditEmployeeModal from '../../components/Employee/EditEmployeeModal/EditEmployeeModal'
import DeleteEmployeeModal from '../../components/Employee/DeleteEmployeeModal/DeleteEmployeeModal';
import api from '../../api/api';

const ManageEmployees = () => {
  const [employees, setEmployees] = useState([])
  const [addEmployeeModalOpen, setAddEmployeeModalOpen] = useState(false)
  const [editEmployeeModalOpen, setEditEmployeeModalOpen] = useState(false)
  const [deleteEmployeeModalOpen, setDeleteEmployeeModalOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [selectedEmployee, setSelectedEmployee] = useState({})

  const fetchData = async () => {
    try{
      const response = await api.get('/employee/byBusiness')
      setEmployees(response.data.listOfEmployees)
    }catch(error) {
      console.log(error)
    }finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleEdit = (employee) => {
    setSelectedEmployee(employee)
    setEditEmployeeModalOpen(true)
  }

  const handleDelete = (employee) => {
    setSelectedEmployee(employee)
    setDeleteEmployeeModalOpen(true)
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">Manage employees</h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => setAddEmployeeModalOpen(true)}
          >
            Add employee
          </button>
        </div>
      </div>
      {
        employees.length > 0 ? (
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                        Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Username
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Phone number
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Status
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Position
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {employees.map((employee) => (
                      <tr key={employee.email}>
                        <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                          <div className="flex items-center">
                            <div className="size-11 shrink-0">
                              <img alt="" src={`https://ui-avatars.com/api/?name=${employee.firstName}+${employee.lastName}&background=4f46e5&color=fff`} className="size-11 rounded-full" />
                            </div>
                            <div className="ml-4">
                              <div className="font-medium text-gray-900">{employee.firstName} {employee.lastName}</div>
                              <div className="mt-1 text-gray-500">{employee.email}</div>
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div className="text-gray-900">{employee.username}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div className="text-gray-900">{employee.phoneNumber}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                            Active
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">{employee.position}</td>
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          <button onClick={() => handleEdit(employee)} className="text-indigo-600 hover:text-indigo-900">
                            Edit
                          </button>
                          <button onClick={() => handleDelete(employee)} className="text-red-600 hover:text-red-900 ml-4">
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className='text-center py-10'>
            <p className="mt-2 text-sm text-gray-700">
              You have 0 employee in your business!
            </p>
          </div>
        )
      }
      


      <AddEmployeeModal addEmployeeModalOpen={addEmployeeModalOpen} setAddEmployeeModalOpen={setAddEmployeeModalOpen} setEmployees={setEmployees}/>

      <EditEmployeeModal editEmployeeModalOpen={editEmployeeModalOpen} setEditEmployeeModalOpen={setEditEmployeeModalOpen} selectedEmployee={selectedEmployee} employees={employees} setEmployees={setEmployees} />

      <DeleteEmployeeModal deleteEmployeeModalOpen={deleteEmployeeModalOpen} setDeleteEmployeeModalOpen={setDeleteEmployeeModalOpen} selectedEmployee={selectedEmployee} employees={employees} setEmployees={setEmployees}/>
      
    </div>
  )
}

export default ManageEmployees